module.exports = __webpack_public_path__ + "static/web-app-6051814a4a4ba693354955456d135ca8.png";